import React from 'react';
import { Text, View, TouchableOpacity } from 'react-native';

import { styles } from './styles';

export const InfoBox = ({ title, detail, style }) => {
  return (
    <View style={[styles.root, styles.card,  style]}>
      <Text style={styles.cardText}>{title}</Text>
      <Text style={styles.cardDetail}>{detail}</Text>
    </View> 
  );
};
